import { Component, OnInit } from '@angular/core';
import { HcNotificationService } from '@cashbox-app/service/hc-notification.service';
import { HxAuthService } from 'hx-services';
import { HeaderComponent } from '../../components/header/header.component';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';
import { HcAlertComponent } from '../../components/hc-alert/hc-alert.component';
import { RouterOutlet } from '@angular/router';
import { CurbsidePickupComponent } from '../../components/curbside-pickup/curbside-pickup.component';
import { FooterComponent } from '../../components/footer/footer.component';

@Component({
    selector: 'app-home.h-100.m-grid.m-grid--hor.m-grid--root.m-page',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    imports: [HeaderComponent, SidebarComponent, HcAlertComponent, RouterOutlet, CurbsidePickupComponent, FooterComponent]
})
export class HomeComponent implements OnInit {
  constructor(
    private notificationService: HcNotificationService,
    private auth: HxAuthService,
  ) {
  }

  ngOnInit() {
    this.notificationService.start(this.auth.user.phone, this.auth.user.store.id);
  }
}
